module.exports = __webpack_public_path__ + "assets/img/rico.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/rico.png
// module id = 699
// module chunks = 0